var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { Dependencies } from "~/core/decorator";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
var ReturncCaseclosure = /** @class */ (function (_super) {
    __extends(ReturncCaseclosure, _super);
    function ReturncCaseclosure() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitLoading = false;
        _this.formCaseClosure = {
            //案件ID
            caseTaskId: undefined,
            //催收总金额=逾期金额+待收代偿+待收费用
            overdueAmount: undefined,
            // 逾期天数
            overdueDays: undefined,
            // 逾期金额(元)
            overdueMoney: undefined,
            // 代偿金额(元)
            compensationMoney: undefined,
            // 逾期期数
            overduePeriod: undefined,
            // 部门催收剩余天数
            partCollectionRemainingDays: undefined
        };
        _this.formRules = {
            overdueAmount: [
                { required: true, message: '请输入催收总金额', trigger: 'blur' }
            ],
            overdueDays: [
                { required: true, message: '请输入逾期天数', trigger: 'blur' }
            ],
            overdueMoney: [
                { required: true, message: '请输入逾期金额', trigger: 'blur' }
            ],
            compensationMoney: [
                { required: true, message: '请输入代偿金额', trigger: 'blur' }
            ],
            overduePeriod: [
                { required: true, message: '请输入逾期期数', trigger: "blur" }
            ],
            partCollectionRemainingDays: [
                { required: true, message: '请输入部门催收剩余天数', trigger: 'blur' }
            ]
        };
        return _this;
    }
    ReturncCaseclosure.prototype.emitClose = function () {
        this.resetDate();
    };
    ReturncCaseclosure.prototype.caseDataChange = function (value) {
        var _this = this;
        this.resetDate();
        if (value) {
            setTimeout(function () {
                _this.formCaseClosure.caseTaskId = value.caseTaskId;
                _this.formCaseClosure.overdueAmount = value.overdueAmount;
                _this.formCaseClosure.overdueDays = value.overdueDays;
            }, 100);
        }
    };
    ReturncCaseclosure.prototype.overdueMoneyChange = function (val) {
        if (this.formCaseClosure.compensationMoney) {
            this.formCaseClosure.overdueAmount = val + this.formCaseClosure.compensationMoney;
        }
        else {
            this.formCaseClosure.overdueAmount = val;
        }
    };
    ReturncCaseclosure.prototype.compensationMoneyChange = function (val) {
        if (this.formCaseClosure.overdueMoney) {
            this.formCaseClosure.overdueAmount = val + this.formCaseClosure.overdueMoney;
        }
        else {
            this.formCaseClosure.overdueAmount = val;
        }
    };
    ReturncCaseclosure.prototype.resetDate = function () {
        this.formCaseClosure = {
            //案件ID
            caseTaskId: undefined,
            //催收总金额=逾期金额+待收代偿+待收费用
            overdueAmount: undefined,
            // 逾期天数
            overdueDays: undefined,
            // 逾期金额(元)
            overdueMoney: undefined,
            // 代偿金额(元)
            compensationMoney: undefined,
            // 逾期期数
            overduePeriod: undefined,
            partCollectionRemainingDays: undefined
        };
        //
        var form = this.$refs["form"];
        try {
            form.resetFields();
        }
        catch (error) {
        }
    };
    ReturncCaseclosure.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["form"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            // 提交
            _this.submitLoading = true;
            _this.telCaseManageService.returnWaitDistribution(_this.formCaseClosure)
                .subscribe(function (data) {
                console.log("[returnc-caseclosure#:112]:", data);
                _this.submitLoading = false;
                _this.$message.success("操作成功");
                _this.emitClose();
            }, function (error) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(TelCaseManageService)
    ], ReturncCaseclosure.prototype, "telCaseManageService", void 0);
    __decorate([
        Prop({ required: true, type: Object })
    ], ReturncCaseclosure.prototype, "caseData", void 0);
    __decorate([
        Emit('close')
    ], ReturncCaseclosure.prototype, "emitClose", null);
    __decorate([
        Watch('caseData', { deep: true, immediate: true })
    ], ReturncCaseclosure.prototype, "caseDataChange", null);
    __decorate([
        Watch('formCaseClosure.overdueMoney')
    ], ReturncCaseclosure.prototype, "overdueMoneyChange", null);
    __decorate([
        Watch('formCaseClosure.compensationMoney')
    ], ReturncCaseclosure.prototype, "compensationMoneyChange", null);
    ReturncCaseclosure = __decorate([
        Component({
            components: {}
        })
    ], ReturncCaseclosure);
    return ReturncCaseclosure;
}(Vue));
export default ReturncCaseclosure;
